module.exports = __webpack_public_path__ + "media/images/official/affiliate_kv-4b3dfc1fe9e24737ca35690c7c7701d4.png";